import { isString } from 'lodash';

export default class Arabic {
  static symbolsRegExp = /[\u0600-\u06FF]/g;

  /**
   * Searches through html elements setting "dir" attribute if the Arabic language prevail in the element
   *
   * @param {string} html
   * @return {string} new html
   */
  static setElementsDirectionInHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const elementsWithText = doc.querySelectorAll('p, span, ol, ul');

    elementsWithText.forEach((element) => {
      if (element.innerText && this.isPrevailInString(element.innerText)) {
        element.setAttribute('dir', 'rtl');
      }
    });

    return doc.body.innerHTML;
  }

  /**
   * Check if the Arabic symbols contains in provided string
   *
   * @param {string} string
   * @return {boolean}
   */
  static isContainedInString(string) {
    if (!string || !isString(string)) {
      return false;
    }

    return string.search(this.symbolsRegExp) !== -1;
  }

  /**
   * Check if string has more arabic chars than the other ones
   *
   * @param {string} string
   * @return {boolean}
   */
  static isPrevailInString(string) {
    if (!string || !isString(string) || !string.length) {
      return false;
    }

    const arabicCharsQuantityInString = this.#countArabicCharsInString(string);
    if (!arabicCharsQuantityInString) {
      return false;
    }

    return arabicCharsQuantityInString >= Math.ceil(string.length / 2);
  }

  /**
   * @param {string} string
   * @return {number}
   */
  static #countArabicCharsInString(string) {
    if (!string || !isString(string)) {
      return 0;
    }

    const match = string.match(this.symbolsRegExp);

    return match ? match.length : 0;
  }
}
